import { Button, Card, Col, Descriptions, Form, Input, Row, Space } from "antd";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
// @ts-ignore
import {get} from 'lodash';
import RoutePath from "../../app/routing/routes.path";
import { CheckOutlined, EditOutlined, ExportOutlined, SnippetsOutlined } from "@ant-design/icons";
import DynamicField from "../../app/components/dynamicField";
import { useState } from "react";
import { updateUserConfig } from "./userThunk";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectSubmitStatus } from "./userSlice";

const colOptions = {
    xxl: 6,
    xl: 8,
    md: 12,
    span: 24,
};

const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export default function ConfigureUser() {
    const device: any = useLoaderData();
    const items = [
        {
            key: 'name',
            label: 'Device Name',
            children: <Link to={`${RoutePath.user}/update/${get(device, 'data._id')}`} >{get(device, 'data.name')}</Link>
        },
        {
            key: 'deviceId',
            label: 'Device Id',
            children: get(device, 'data.deviceId')
        },
        {
            key: 'imei',
            label: 'Device IMEI',
            children: get(device, 'data.imei')
        },
        {
            key: 'type',
            label: 'Device Type',
            children: <Link to={`${RoutePath.deviceType}/update/${get(device, 'data.deviceType._id')}`} target="_blank" >{get(device, 'data.deviceType.name')} <ExportOutlined /></Link>
        },
    ]
    const Configs = get(device, 'data.deviceType.config', []);
    return (<>
        <Descriptions title="Device Info" items={items} bordered column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 4, xxl: 4 }}/>
        <br/>
        <Row justify="space-between" gutter={[10,10]}>
            {Configs.map((config: any) => (
                <Col {...colOptions}><ConfigCard config={config} device={device.data}/></Col>
            ))}
            
        </Row>
    </>
    );
}

function ConfigCard(props: {config: any, device: any}) {
    const {config, device} = props;
    const [mode, setMode] = useState('view');
    const [formRef] = Form.useForm();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const submitStatus = useAppSelector(selectSubmitStatus);

    const ActionIcon = (mode == 'view'? 
        <Button onClick={()=>setMode('update')} icon={<EditOutlined />} >Edit</Button>
        :
        <Button onClick={formRef.submit} type="primary" icon={<CheckOutlined />} >Save</Button>
    )

    async function onFinish(values: any) {
        console.log(values);

        await dispatch(updateUserConfig({
            id: device._id,
            configKey: config.key,
            body: values
        }));
        setMode('view');
    }
    function onFinishFailed(errorInfo: any) {
        console.log('Failed:', errorInfo);
    }
    

    return (
        <Card title={config.title} extra={ActionIcon}>
            <Form
                {...formLayout}
                initialValues={device.config && device.config[config.key] || {}}
                disabled={mode=='view' || submitStatus == "submitting"}
                name={`${config.key}-form`}
                form={formRef}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}>
                {(config.fields || []).map((f: any) => (<DynamicField field={f} />))}
            </Form>
        </Card>
    )
}